/*
  Have to use GLOBAL_CONFIG here
  Can't use getDefaultConfig() here since can't access store before initialization
*/
const { rootDomain } = GLOBAL_CONFIG;

// This is separate from `Tracking/index.js`, since that file is imported inside `src/index.js`,
// and keeping this object inside that file would lead to import cycles that cause bugs
// without triggering any errors (would cause the `trackingInitialState` to initialize as
// `undefined` inside the `initialState`)
export const trackingInitialState = {
  source: null,
  pageStartSource: document.referrer === `${rootDomain}/` ? 'marketing landing' : 'other',
  selected_plan: null,
  pageName: {},
  purchaseSource: '',
};
